/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconClearFormatting = createReactComponent("outline", "clear-formatting", "IconClearFormatting", [["path", { "d": "M17 15l4 4m0 -4l-4 4", "key": "svg-0" }], ["path", { "d": "M7 6v-1h11v1", "key": "svg-1" }], ["path", { "d": "M7 19l4 0", "key": "svg-2" }], ["path", { "d": "M13 5l-4 14", "key": "svg-3" }]]);

export { IconClearFormatting as default };
//# sourceMappingURL=IconClearFormatting.mjs.map
